import { useEffect } from 'react';
import { Session } from '@om/shared-auth';

/**
 * Hook to refresh SuperTokens sessions on app load
 */
export const useTokenRefresh = () => {
  useEffect(() => {
    const refreshSession = async () => {
      try {
        const sessionExists = await Session.doesSessionExist();
        if (!sessionExists) {
          return;
        }

        await Session.attemptRefreshingSession();
      } catch {
        // Ignore refresh errors on app load. Session boundary logic handles unauthenticated state.
      }
    };

    void refreshSession();
  }, []);

  const refreshSessionManually = async () => {
    return await Session.attemptRefreshingSession();
  };

  return {
    refreshSessionManually,
  };
};